import { InputField } from "kubra-ux-forge";
import React from "react";
import { useField } from "formik";
import { getWcagAutocompleteValue } from "utilities/wcag";

interface IntegerFieldProps {
  name: string;
  label: string;
  placeholder?: string;
  editableIfPrefilled?: boolean;
}

export const IntegerField: React.FC<IntegerFieldProps> = ({
  label,
  name,
  placeholder,
  editableIfPrefilled,
}) => {
  const [field, meta] = useField(name);

  let disabled = false;

  if (meta.initialValue && !editableIfPrefilled) {
    disabled = true;
  }

  return (
    // TODO: use appropriate class.
    <div className="bank-account-name-textbox-container">
      <InputField
        {...field}
        name={name}
        errorText={meta.touched ? meta.error : undefined}
        hasError={meta.touched ? !!meta.error : false}
        aria-invalid={meta.touched && !!meta.error}
        label={label}
        dataCy={name}
        autoComplete={getWcagAutocompleteValue(name, label)}
        placeholder={placeholder}
        disabled={disabled}
      />
    </div>
  );
};
